import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import drugData from '../data/drugs.json';

export default function DrugDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    const drug = drugData.find(d => d.id === id);

    if (!drug) return <div style={{ padding: '20px', textAlign:'center', color:'#c0392b', paddingTop: 'max(20px, env(safe-area-inset-top))' }}>İlaç bulunamadı!</div>;

    return (
        <div style={containerStyle}>
            {/* Geri tuşu artık geçmişteki sayfaya (Rehber Listesi) akıllıca döner */}
            <button 
                onClick={() => navigate(-1)} 
                style={backButtonStyle}
            >
                ← Geri Dön (İlaç Rehberi)
            </button>
            
            <div style={cardStyle}>
                <h1 style={nameStyle}>{drug.name}</h1>
                <div style={categoryBadge}>{drug.category}</div>

                <div style={infoContent}>
                    {/* KLİNİK REFERANS DOZLARI */}
                    <div style={referenceBox}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#27ae60' }}>⚖️ Klinik Referans Dozajlar</h4>
                        <div style={specRow}><strong>🐕 Köpek:</strong> {drug.dosage_dog}</div>
                        <div style={specRow}><strong>🐈 Kedi:</strong> {drug.dosage_cat}</div>
                    </div>

                    <hr style={divider} />

                    {/* İLAÇ AYRINTILARI */}
                    <Section title="🔬 Etki Mekanizması" content={drug.mechanism} />
                    <Section title="📋 Kullanım Alanları" content={drug.usage} />
                    <Section title="🛡️ Güvenlik & Uygulama Notları" content={drug.safety} color="#2980b9" />
                    <Section title="🚫 Kontrendikasyonlar" content={drug.contraindications} color="#c0392b" />
                    <Section title="⚠️ Yan Etkiler" content={drug.side_effects} />
                    <Section title="🔗 İlaç Etkileşimleri" content={drug.interactions} />
                </div>
            </div>
        </div>
    );
}

// Yardımcı Bölüm Bileşeni
const Section = ({ title, content, color = "#2c3e50" }) => {
    if (!content) return null;
    return (
        <div style={{ marginBottom: '25px', wordBreak: 'break-word' }}>
            <h3 style={{ color: color, fontSize: '17px', borderBottom: '2px solid #f1f2f6', paddingBottom: '8px', marginBottom: '10px' }}>
                {title}
            </h3>
            <p style={{ fontSize: '15px', lineHeight: '1.6', color: '#444', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {content}
            </p>
        </div>
    );
};

// --- STİLLER (Mobil ve iOS Safe-Area Uyumlu) ---
const backButtonStyle = { 
    background: 'none', 
    border: 'none', 
    color: '#3498db', 
    fontWeight: 'bold', 
    cursor: 'pointer', 
    marginBottom: '20px', 
    display: 'block', 
    fontSize: '14px',
    padding: '0',
    WebkitTapHighlightColor: 'transparent'
};

const containerStyle = { 
    padding: '15px', 
    maxWidth: '800px', 
    margin: '0 auto', 
    fontFamily: 'Segoe UI, sans-serif',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', // iOS Çentik Koruması
    paddingBottom: 'env(safe-area-inset-bottom)'       // iOS Alt Bar Koruması
};

const cardStyle = { 
    background: '#fff', 
    padding: '20px', 
    borderRadius: '20px', 
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    boxSizing: 'border-box',
    width: '100%'
};

const nameStyle = { margin: '0', color: '#2c3e50', fontSize: '26px', fontWeight: 'bold', wordBreak: 'break-word' };

const categoryBadge = { display: 'inline-block', padding: '5px 15px', background: '#3498db', color: '#fff', borderRadius: '25px', fontSize: '13px', marginTop: '10px' };

const referenceBox = { background: '#fafffa', padding: '15px', borderRadius: '12px', border: '1px solid #d4edda', marginTop: '20px', boxSizing: 'border-box' };

const specRow = { fontSize: '15px', marginBottom: '8px', color: '#155724', wordBreak: 'break-word' };

const divider = { border: '0', height: '1px', background: '#eee', margin: '25px 0' };

const infoContent = { marginTop: '10px' };